import {
  Modal,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
} from "react";
import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [propId, setPropId] = useState(null);
	const [modalFlag, setModalFlag] = useState(false);

	useImperativeHandle(ref, () => ({
		openModal: (id) => {
			setPropId(id)
			setModalFlag(true)
		}
	}));

	const initFn = () => {
    setPagination({
      current: 1,
      pageSize: 25,
      total: 0,
    })
		setTableList([])
		setTableLoading(false)
	}

	const afterOpenChangeFn = (flag) => {
		if(flag){
			getTableListFn()
		}else{
			initFn()
		}
	}

  const initColumns = [
    {
      title: 'Prop - Address City State - Unit #',
      dataIndex: "addressCityStateZip",
      titleType: '',
      isSorter: false,
      sortterMultiple: 3,
      width: 300,
    },
    {
      title: 'Prop Type',
      dataIndex: "propType",
      titleType: '',
      isSorter: false,
      sortterMultiple: 3,
    },
    {
      title: 'Ratio',
      dataIndex: "loanRatio",
      titleType: '',
      isSorter: false,
      isPercent: true,
      sortterMultiple: 3,
    },
    {
      title: 'Monthly',
      dataIndex: "monthlyFee",
      titleType: '',
      isSorter: false,
      sortterMultiple: 3,
    },
    {
      title: "Current Loan",
      dataIndex: "currentLoan",
      titleType: "",
      width: 100,
      isSorter: false,
      sortterMultiple: 3,
      isAmountFlag: true,
    },
    {
      title: "Original Loan",
      dataIndex: "originalLoan",
      titleType: "",
      width: 100,
      isSorter: false,
      sortterMultiple: 3,
      isAmountFlag: true,
    },
    {
      title: "Allocation",
      dataIndex: "allocation",
      titleType: "",
      width: 100,
      isSorter: false,
      sortterMultiple: 3,
      isAmountFlag: true,
    },
    {
      title: 'Paid Off Date',
      dataIndex: "paidOffDate",
      titleType: '',
      isSorter: false,
      format: 'MM/DD/YYYY',
			render:((text) => text && moment(text).format("MM/DD/YYYY"))
    },
    {
      title: 'Sold Date',
      dataIndex: "soldDate",
      titleType: '',
      isSorter: false,
      format: 'MM/DD/YYYY',
			render:((text) => text && moment(text).format("MM/DD/YYYY"))
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      id: propId
    };
    const response = await http.get(api.mortgageApprovalList, {params});
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    setTableList(response.data?.list || []);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination) => {
    getTableListFn(pagination.current, pagination.pageSize);
  };

  return (
    <Modal
      title="View Payment History"
			centered
			open={modalFlag}
      onCancel={() => setModalFlag(false)}
			footer={null}
			maskClosable={false}
			destroyOnClose={true}
			afterOpenChange={afterOpenChangeFn}
			width="80%"
    >
			<CustomTable 
				tableLoading={tableLoading}
				rowKey="id"
				columns={columns}
				tableList={tableList}
				pagination={pagination}
        handleTableChange={handleTableChange}
			/>
    </Modal>
  );
});
export default MainTable;
